import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    alias: "/",
    name: "Login",
    component: require("../views/Login.vue").default,
    meta: {
      name: "Login"
    }
  },
  {
    path: "/home",
    name: "Home",
    component: require("../views/Home.vue").default,
    meta: {
      name: "Home",
      auth: {
        isLoggedIn: true
      }
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: require("../views/Settings.vue").default,
    meta: {
      name: "Settings",
      auth: {
        isLoggedIn: true
      }
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  let userInfo: any = {};
  if (!store.getters["userInfo"].userSignedIn) {
    userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  }

  if (Object.keys(userInfo).length !== 0) {
    store.dispatch("setUserInfo", userInfo);
  }

  if (
    to.matched.some(record => record.meta.auth) &&
    !store.getters["userInfo"].userSignedIn
  ) {
    next({
      path: "/login"
    });
  } else {
    let title = "Payment Application";
    title += to.meta.name != undefined ? " - " + to.meta.name : "";
    document.title = title;
    next();
  }
});

export default router;
